import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from "react";
import Title from "app/components/Title";
import { Form, Formik } from "formik";
import { Alert, LoadingButton } from "@mui/lab";
import { usePartyChangeMarketingCommsStatusMutation } from "generated/generated-models";
import { useSecurityTokenMutation } from "core/apollo/SecurityTokenApollo";
import RequestMultiFactorTokenFormik from "app/components/RequestMultiFactorTokenFormik";
import { Validate, } from "./ProfileMarketingCommunicationsInputValidator";
import { Button } from "@mui/material";
const ProfileMarketingCommunications = ({ ProfileId, MarketingStatus, }) => {
    const [marketingCommsStatus, setMarketingCommsStatus] = useState(undefined);
    const [changeMarketingStatus, { data: changeMarketingStatusData, error: changeMarketingStatusError },] = useSecurityTokenMutation(usePartyChangeMarketingCommsStatusMutation());
    const [marketingCommsMFA, setMarketingCommsMFA] = useState("WithoutMFA");
    const handleRequiresMFA = () => {
        setMarketingCommsMFA("WithMFA");
    };
    const handleMarketingCommsSubmit = async (values) => {
        const result = await changeMarketingStatus({
            variables: {
                input: {
                    MarketingStatus: !values.MarketingStatus,
                    TwoFactorToken: values.TwoFactorToken,
                },
            },
        });
        if (result.data?.changeMarketingCommsStatus?.Code === "499") {
            handleRequiresMFA();
        }
        if (result.data?.changeMarketingCommsStatus?.Success) {
            setMarketingCommsStatus(true);
            setTimeout(() => {
                setMarketingCommsStatus(true);
                window.location.reload();
            }, 3000);
        }
    };
    return (_jsx(Formik, { initialValues: {
            ProfileId: ProfileId,
            MarketingStatus: MarketingStatus,
        }, onSubmit: (values) => handleMarketingCommsSubmit(values), validationSchema: Validate(marketingCommsMFA === "WithMFA"), children: ({ isSubmitting }) => {
            return (_jsxs(_Fragment, { children: [_jsx(Title, { title: "Marketing Communications" }), _jsxs("p", { className: "intro-text", children: ["You are about to", " ", !MarketingStatus
                                ? "opt in to receive"
                                : "opt out from receiving", " ", "marketing communications. Please confirm you are happy to proceed."] }), _jsxs(Form, { children: [!marketingCommsStatus && (_jsx(RequestMultiFactorTokenFormik, { name: "TwoFactorToken", showRequestNewToken: true, requestMfaOnDisplay: true, visible: marketingCommsMFA === "WithMFA" })), (changeMarketingStatusError ||
                                changeMarketingStatusData
                                    ?.changeMarketingCommsStatus?.Success ===
                                    false) && (_jsx(Alert, { severity: "error", children: changeMarketingStatusData
                                    ?.changeMarketingCommsStatus
                                    ?.Message })), marketingCommsStatus ? (_jsx(Alert, { severity: "success", children: "You have successfully updated your marketing communication settings." })) : (_jsxs("div", { className: "button-row", children: [_jsx(Button, { className: "btn-cancel", id: "cancel", sx: { p: 1.5, mt: 1 }, variant: "contained", onClick: () => window.location.reload(), children: "Cancel" }), _jsx(LoadingButton, { type: "submit", id: "submit", sx: { p: 1.5, mt: 1 }, loading: isSubmitting, loadingPosition: "end", variant: "contained", children: "Confirm" })] }))] })] }));
        } }));
};
export default ProfileMarketingCommunications;
